module.exports = __webpack_public_path__ + "img/1532284323.3dd744d6.jpg";